import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My old code is atrocious",
  "description": "",
  "published": "2013-11-12T00:00:00.000Z",
  "redirect_from": ["/blog/my-old-code-is-atrocious/swizec/6414"],
  "categories": "Haskell, Languages, Programming, Spaghetti code, Toshl, Uncategorized",
  "hero": "./img/images-3841.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "478px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/0c5f1842632f6d0ecc6028f11588a679/50978/images-3841.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "64.57399103139014%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'259\\'%20viewBox=\\'0%200%20400%20259\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20130v129h401V0h-80l-44%201h36v20c0%2024-1%2022%2012%2023l11%201%207%201%205%201%2014%201c10%200%2011%200%2013%202s2%202%2011%201a39%2039%200%200012-3l1%20133c-1%204-7%208-13%208l-4%201-1-4c0-5-1-6-4-6s-5%207-6%2014c0%2012%200%2012-4%2011-3%200-5-1-3-2v-4c0-2%200-2-2-1h-5c-3-2-5-2-6%200s-1%202%202%201l4%201c0%203-9%202-16-2a441%20441%200%2000-13-7c2-1-1-3-8-3-6-1-6-1-9%202l-2%201c0-2-2-1-3%201-2%204-3%203-3-2-2-6%202-17%204-15l6%201c6%200%208-3%2011-11l4-7c2-2%202-3%201-4v-6l2-1c4%203%2045%204%2048%201%203-2%202-4-1-7a157%20157%200%2000-39-20l1-9c1-7%201-9-1-15V86c1-2%202-4%201-6l1-6%202-7%201-9c0-5%202-5-18-5-12-1-12-1-14%202-1%202-1%202-8-1-3-1-15-3-16-2h-5c-6%201-7%202-13%205l-10%205c-6%202-6%203-6%205l-1%202c-3%200-14%2013-18%2021-3%205-4%206-6%206a1340%201340%200%2000-24-3c-2-2-11-4-19-4h-7c0-1-6-2-13-2l-23-3c-2-1%200-3%201-2l21%201%2031%201h12V53l-4-1h-16c-10%201-11%201-9-3s5-5%2014-6l8-2%204-2c4%200%204%200%205-21%200-16%200-17%202-17a1256%201256%200%2000-85%201l-6%203-25%209c-7%202-7%202-13%201-17-5-42-6-51-3l-12%202-16%204c-2%201-3-1-3-10V1h17l17-1H0v130M101%2023l6%2011%204%204%201%202c2%201%202%207%200%209-3%203-1%205%204%204l5%201%203%201c2%200%202%200-1-3s-7-11-7-14l-14-16-1%201M56%2084c-3%203-3%206-2%2013l1%206c-1%202%200%202%202%201%201-1%202%200%203%201h2c-5-11-2-22%204-21%204%200%200-2-4-2-3-1-4-1-6%202m64%204l-1%204c-2%200-3%200-2%201l1%207v6c2%203%200%209-2%209-1%201-2%202-2%205-1%204%200%207%201%204l2-1%202-3c3-8%208-2%209%208%200%205%200%206%203%207%207%205%209%208%208%2010-3%203-13%207-23%2010l-13%203-8%205-1%202-7%2011%201%205%202%204c0%202%203%203%2016%208%2014%204%2017%204%2018%203l2-1-1%202v1l3%2011a51%2051%200%20003%2015l3%208c4%207%205%203%202-4-2-4-2-6-1-8l1-9c0-6%201-14%203-15%201-1%203-6%202-9l1-5c2-2%203-1%203%202%200%202%201%203%206%207%203%202%203%209%201%2017-1%205%200%2024%202%2024%201%200%202-3%202-14%201-12%202-23%204-30%201-4%207-6%2019-6l12%201%202%201c3%200%204%205%204%2015%200%208%200%208%208%204l23-5c7%200%205-2-3-5-5-2-6-4-1-5l4-4c0-2%201-4%203-4l4-1h2l-2-3-4-2c-1%200-1-1%201-2s2-2%201-2h-2l4-2c5%200%206-2%203-2l-3-1c0-2-7-1-8%202l-4%201c-2%200-2-1-1-6%201-4%201-4%205-4l5%201c1%201%200%201-3%201l-4%201%203%201%205%201c2%200%202%200%201-3l-1-7c0-4-1-5-3-7-4-1-4-2-6%203-2%204-4%206-5%206-1-1%204-11%206-13%202-1%203-4%204-6%201-4%2012-16%2014-16%204%200%205-5%202-8-4-3-8-2-7%202v3l-6-2c-5-1-8%200-7%202l5%201%206%202v1l-5-2h-3l2%201c4%202%204%205%200%206-3%200-4-1-2-2v-2c-1-1-2-1-2%201v1l-36-14c-4-2-8-2-27-2-24-1-24-1-26-6%200-2%200-3-1-2-2%201-5-1-5-6-1-2-1-3%201-4%203-2%203-3-1-3-1%201-3%200-5-1-4-3-5-3-6%202m-73%2024l-1%202-2%204-2%203c0%203-4%205-6%204-6-2-9%200-10%207-1%205-4%205-12%200-6-4-7-6-9-9-2-7-3-5-3%205v10h6l10%201%207%201%208%202%208%202c3%200%206-2%204-3l-1-3c0-2%205-3%209-1%202%202%203%202%204-1l1-7-2-10c-1-7-3-9-9-7m209%2011c-2%201-1%202%202%202%202%200%203%200%203%202s-1%202-4%202h-4v4l1%205-1%202c-3%200-5%203-5%205l-1%203c-2%202-2%203-1%204%202%202%206%2010%206%2013%200%202%200%202-1%201-2-2-4-3-5-1l2%204%203%207c0%203%201%203%204-1l2-9%201-8%202-4%201-3c4%200%2011-9%208-11v-1l-4-5-3-3%202-2%202-3-3-2c-4-2-6-3-7-1M70%20148c1%208%205%2014%209%2014v-10l-3-4-5-5-1%205m99%2047l3%204%202%205%201%205v8c0%208%201%208%205%205%203-2%203-3%203-8l2-12c3-8%202-9-8-9-7%200-8%201-8%202m-74%203l9%207%205%204%208%205%202-4c0-5%202-7%204-6v-1l-8-3-9-2H95m143%2013a420%20420%200%200011%2042%201123%201123%200%20013-22c0-2%200-3-2-5l-3-4-9-11\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0c5f1842632f6d0ecc6028f11588a679/ca0a1/images-3841.webp 223w", "/static/0c5f1842632f6d0ecc6028f11588a679/75680/images-3841.webp 445w", "/static/0c5f1842632f6d0ecc6028f11588a679/2b263/images-3841.webp 478w"],
                "sizes": "(max-width: 478px) 100vw, 478px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0c5f1842632f6d0ecc6028f11588a679/e92b6/images-3841.png 223w", "/static/0c5f1842632f6d0ecc6028f11588a679/e66bf/images-3841.png 445w", "/static/0c5f1842632f6d0ecc6028f11588a679/50978/images-3841.png 478w"],
                "sizes": "(max-width: 478px) 100vw, 478px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0c5f1842632f6d0ecc6028f11588a679/50978/images-3841.png",
                "alt": "Fixing others' code",
                "title": "Fixing others' code",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Fixing others' code`}</figcaption>{`
  `}</figure></p>
    <p>{`Fixing old code is always a humbling experience. Especially your own.`}</p>
    <p>{`That's a lie. Fixing other people's old code is a maddening experience that puts you in a stabby mood. At the very least you'd like to punch the programmer in the face repeatedly while screaming `}<em parentName="p">{`"WHY DID YOU DO THAT LIKE THAT WHAT WERE YOU THINKING ARE YOU A COMPLETE IDIOT OR JUST A TOTAL IDIOT?"`}</em>{` and showering them with spit. Veins popping out of your neck and forehead. Face going red. The whole spiel.`}</p>
    <p>{`Your own code though ... that's humbling.`}</p>
    <h2 {...{
      "id": "fixing-an-old-project"
    }}>{`Fixing an old project`}</h2>
    <p>{`A few weeks ago, closer to a month or two than a fortnight, a project of mine suddenly went offline. I usually don't notice, which is a terrible habit, but I tend to build cool things, being excited for a week or two, then letting them rot and fall offline.`}</p>
    <p>{`But not `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/Personal-Runway"
      }}>{`this project`}</a>{`. This is my crowning glory, the coolest thing I've ever built. That strange cacophony of technologies that sends me an email every few days saying `}<em parentName="p">{`"Hey you, you're doing fine. Keep spending."`}</em>{` or `}<em parentName="p">{`"What the fuck are you doing idiot? Your money is vanishing! STAHP!"`}</em></p>
    <p>{`It's really neat.`}</p>
    <p>{`But man is it built out of some truly atrocious code. It started as a `}<a parentName="p" {...{
        "href": "http://haskell.org",
        "title": "Haskell (programming language)"
      }}>{`Haskell`}</a>{` learning experiment over new year's break two years ago and, you know, back then I really thought I was a great engineer.`}</p>
    <p>{`Last night I almost cried.`}</p>
    <h2 {...{
      "id": "atrocities"
    }}>{`Atrocities`}</h2>
    <p>{`The first atrocity committed in the name of hacking was writing the program in two distinct languages for reasons that were weak at best.`}</p>
    <p>{`I used node.js to drive the main process and talk to API's. `}<inlineCode parentName="p">{`runner.js`}</inlineCode>{` calls other parts of the code, talks to mongodb, and runs the algorithmic Haskell part as a subprocess.`}</p>
    <p>{`The Haskell and node.js part communicate via mongodb.`}</p>
    <p>{`I didn't even use a mongodb library. Hacked something together because mongoose - ORM-like mongodb library for node - was too slow for some reason. And I have no idea how Haskell does it. Monads continue to confuse me.`}</p>
    <p>{`To make matters even more worse, I didn't use any libraries to talk to either `}<a parentName="p" {...{
        "href": "http://www.toggl.com",
        "title": "Toggl.com"
      }}>{`Toggl`}</a>{` or `}<a parentName="p" {...{
        "href": "http://toshl.com/"
      }}>{`Toshl`}</a>{`. Partly because Toshl only released an official API this summer and other than `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/about-achieving-polymorphism-in-javascript/swizec/6370"
      }}>{`my half baked attempt from two weeks ago`}</a>{` there are no libraries, partly because I don't know why.`}</p>
    <p>{`The Toshl part is the worst. I fake user interactions to log into their service and export a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Comma-separated_values",
        "title": "Comma-separated values"
      }}>{`CSV file`}</a>{` with data, then parse it locally.`}</p>
    <p>{`Yes that includes sending plaintext passwords over https. Yes it also includes saving said password in a file on the server.`}</p>
    <p>{`Why yes, yes I do use that email/password combination elsewhere.`}</p>
    <p>{`Wonderful innit?`}</p>
    <p>{`And don't even get me started on the Toggl implementation. That's what broke by the way. Version 6 of their API was deprecated on September 1st and I just didn't notice.`}</p>
    <p>{`I `}<em parentName="p">{`know`}</em>{` there was a library for Toggl. I even remember using it. But the code I was fixing last night used `}<a parentName="p" {...{
        "href": "https://github.com/visionmedia/superagent"
      }}>{`superagent`}</a>{` to make JSON requests manually.`}</p>
    <p>{`Yes that includes setting `}<inlineCode parentName="p">{`Accept: application/json`}</inlineCode>{` headers and utf8 encoding.`}</p>
    <p>{`Yup, there also wasn't any abstraction at all. The three API calls were meticulously spelled out. Everything from bits of the URL (https, toggl.com, ...), to specifying the headers every time.`}</p>
    <p>{`All of that became this function:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var __request = function (url, query, callback) {
  callback = arguments[arguments.length - 1];
  query = typeof query === "function" ? {} : query;

  request
    .get({
      protocol: "https",
      hostname: "www.toggl.com",
      pathname: url,
      query: query,
      auth: require("./secrets").toggl_api + ":api_token",
    })
    .set("Accept-Charset", "utf-8")
    .set("Accept", "application/json")
    .end(callback);
};
`}</code></pre>
    <p>{`Which lets me do this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var workspaces = function (callback) {
  __request("/api/v8/workspaces", callback);
};
`}</code></pre>
    <p>{`Much better than essentially having `}<inlineCode parentName="p">{`__request`}</inlineCode>{` function repeated every time.`}</p>
    <p>{`Had I been using an actively developed library maybe my project wouldn't break. Somebody else would make sure my code still knew how to talk with Toggl by virtue of updating their library.`}</p>
    <p>{`Alas, I was being an idiot. Alas alas I didn't `}<em parentName="p">{`really`}</em>{` fix the situation last night either.`}</p>
    <p>{`To top it off, the CSV parsing library changed in the newer version so I had to fix that part of my code as well.`}</p>
    <p>{`And I will never understand why looping through aaaaaall the data for both Toshl and Toggl was a good idea when all I care about are the last three days. Everything else is in mongodb anyway.`}</p>
    <p>{`Another time maybe. When I once more muster the courage to go fixing my old code.`}</p>
    <p>{`I just hope I still know enough Haskell to fix the algorithmic part if it ever breaks. No comments. No explanation of the algorithm. D'oh.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=36ac71d4-54e8-45d0-a899-64e537bd545a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      